import { DOCUMENTS_CRUD_ACTION_CREATORS } from '../actions/documents_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';

export const documentsRestCrudThunksForBuyer = new RestCrudThunks(
	'documents',
	'document',
	'document',
	'documents',
	DOCUMENTS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false
);

export const documentsRestCrudThunksForSupplier = new RestCrudThunks(
	'documents',
	'document',
	'document',
	'documents',
	DOCUMENTS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false
);

export const locationDocumentsRestCrudThunksForBuyer = new RestCrudThunks(
	'location_documents',
	'document',
	'document',
	'location_documents',
	DOCUMENTS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'location/'
);

export const locationDocumentsRestCrudThunksForSupplier = new RestCrudThunks(
	'location_documents',
	'document',
	'document',
	'location_documents',
	DOCUMENTS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'location/'
);

